function dropdown() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const head = document.querySelector('.gh-navigation');
    if (!head) return; // Shared premium navigation does not use Ghost's overflow menu.
    const menu = head.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav) return;

    const logo = document.querySelector('.gh-navigation-logo');

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = `${0.03 * (index + 1)}s`;
        });
    }

    // Collapsing overflowing items into a "..." button is disabled: GoTixi's
    // nav items (About Us, Drops) carry their own <button> + click handling +
    // absolutely-positioned dropdown panel, and moving one into ANOTHER
    // <button> here (invalid HTML — button nested in button) broke its click
    // handling. GoTixi's burger menu already replaces the whole nav below its
    // own breakpoint, so items are just left in place above it; only the
    // "reveal the nav" step (see .is-dropdown-loaded in screen.css) still runs.
    const makeDropdown = function () {
        if (mediaQuery.matches) return;
        head.classList.add('is-dropdown-loaded');
    }

    imagesLoaded(logo, function () {
        makeDropdown();
    });

    window.addEventListener('load', function () {
        if (!logo) {
            makeDropdown();
        }
    });

    // No resize listener: this used to do `nav.innerHTML = navHTML` on every
    // resize to rebuild the row from scratch before re-running the collapse
    // check above. Since collapsing is gone, that reset served no purpose —
    // and it was actively destructive: replacing the <li> nodes destroys the
    // About Us/Drops <button> elements that navigation.hbs's own script
    // attaches click listeners to exactly once, at initial page load. Any
    // resize event (window drag, OS display change, even opening devtools)
    // silently killed every dropdown for the rest of that page's life.
}
